import { CircleX } from "lucide-react";
import * as React from "react";

import { Alert } from "@/components/ui";
import { cn } from "@/lib/utils";
import { VideoProject } from "@/services/bedrock";

interface QaReturnedCalloutProps {
  videoProject: VideoProject;
  onReview?: () => void;
}

function isBeforeQaReview(status: VideoProject.Status) {
  return status === VideoProject.Status.SUBMITTED_FOR_EDITING || status === VideoProject.Status.EDITING;
}

export function QaReturnedCallout({ videoProject, onReview }: QaReturnedCalloutProps) {
  if (videoProject.qaStatus !== "REJECTED" || !isBeforeQaReview(videoProject.status)) return null;

  return (
    <Alert
      variant="destructive"
      className={cn(
        "border-red-200 bg-red-50 text-red-900 *:data-[slot=alert-description]:text-red-900",
        onReview && "cursor-pointer transition-colors hover:bg-red-100/80"
      )}
      onClick={onReview}
      role={onReview ? "button" : "alert"}
      tabIndex={onReview ? 0 : undefined}
      onKeyDown={
        onReview
          ? event => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onReview();
              }
            }
          : undefined
      }
      aria-label={onReview ? "Review QA notes" : undefined}
    >
      <CircleX />
      <Alert.Title>QA left notes on this cut</Alert.Title>
      <Alert.Description>Review them, then resubmit.</Alert.Description>
    </Alert>
  );
}
